import React, { createContext, Dispatch, PropsWithChildren, SetStateAction, useState } from "react";
import { ErrorModalState } from "./types";

export type ContextType = [ErrorModalState, Dispatch<SetStateAction<ErrorModalState>>];

export const ErrorModalContext = createContext<ContextType | undefined>(undefined);

export const ErrorModalContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [errorModalState, setErrorModalState] = useState<ErrorModalState>({
    error: undefined,
    isOpen: false,
    resend: () => {},
  });
  const context = React.useMemo(
    (): ContextType => [errorModalState, setErrorModalState],
    [errorModalState, setErrorModalState],
  );

  return <ErrorModalContext.Provider value={context}>{children}</ErrorModalContext.Provider>;
};
